import React from "react";
import { useTranslation } from "react-i18next";
import { usePageTitle } from "@/components/layout/hooks/usePageTitle";

export const RequestsSettingsPage: React.FC = () => {
  const { t } = useTranslation();
  usePageTitle();

  return (
    <div className="flex flex-col gap-6 p-12">
      <h1 className="text-2xl font-semibold">
        {t("layout.nav.items.requests")}
      </h1>
      <p className="text-muted-foreground">
        {t("requests.settings.comingSoon")}
      </p>
    </div>
  );
};
